import { EOnboardingChosenReason, ONBOARDING_CHOSEN_REASONS } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DescriptionWrapper, Wrapper } from './ReasonChooseSelector.styles';

type ReasonChooseSelectorProps = {
  value?: EOnboardingChosenReason;
  onChange?: (value: EOnboardingChosenReason) => void;
  allowClear?: boolean;
  disabled?: boolean;
  disableDescription?: boolean;
  placeholder?: string;
};

export const ReasonChooseSelector: React.FC<ReasonChooseSelectorProps> = ({
  value,
  onChange,
  allowClear = false,
  disabled = false,
  disableDescription = false,
  placeholder
}) => {
  const { t } = useTranslation('DefaultTranslations');
  const options = useMemo(
    () =>
      ONBOARDING_CHOSEN_REASONS.map(reason => ({
        label: t(reason),
        value: reason
      })),
    []
  );

  return (
    <Wrapper>
      {!disableDescription && <DescriptionWrapper>{t('THIS_DATA_IS_PRIVATE')}</DescriptionWrapper>}
      <Select
        showSearch
        value={value}
        options={options}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={placeholder || t('CHOOSE_AN_OPTION')}
        style={{ minWidth: '200px' }}
        disabled={disabled}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Wrapper>
  );
};
